import i18next from 'i18next';

import { publishedAnnouncementsSlice } from './AnnouncementsSlice';
import { notificationSlice } from '../Notification/NotificationSlice';
import { Dispatch } from '../types';
import ApiService from '../../Services/ApiService';

export const fetchPublishedAnnouncements =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(publishedAnnouncementsSlice.actions.setIsFetching(true));

    try {
      const announcements = await ApiService.fetchPublishedAnnouncements();
      dispatch(publishedAnnouncementsSlice.actions.setAnnouncements({ announcements }));
    } catch (error: any) {
      dispatch(
        notificationSlice.actions.setError({
          message: i18next.t('notifications.failedToLoadAnnouncements'),
        }),
      );
    } finally {
      dispatch(publishedAnnouncementsSlice.actions.setIsFetching(false));
    }
  };
